import PropTypes from 'prop-types'
import React from 'react'
import QuestionCard from './QuestionCard'

import styles from './QuestionList.module.scss'

const QuestionList = ({ questions, total, handleExpandChange }) => (
  <div className={styles.questions}>
    <div className={styles.result}>
      <label className={styles['label-result']}>Resultado da busca</label>
      {total && <div className={styles['div-total']}>Exibindo {total}</div>}

      {questions.map((question, index) => (
        <div key={question.id}>
          <QuestionCard
            question={question}
            questionIndex={index}
            handleExpandChange={handleExpandChange}
          />
        </div>
      ))}
    </div>
  </div>
)

QuestionList.propTypes = {
  questions: PropTypes.array.isRequired,
  total: PropTypes.number.isRequired,
  handleExpandChange: PropTypes.func.isRequired,
}

export default QuestionList
